import React from 'react'
import join from 'lodash/join'
import map from 'lodash/map'
import { useProductMetadata } from '../useProductMetadata'

export const useDefaultMetadata = () => {
  const { metadataSchema } = useProductMetadata()

  const categoryOptions = join(map(metadataSchema?.category?.inputProps?.options, 'value'), ', ')
  const dieSetTypeOptions = join(map(metadataSchema?.dieSetType?.inputProps?.options, 'value'), ', ')
  const shapeOptions = join(map(metadataSchema?.shape?.inputProps?.options, 'value'), ', ')

  return [
    {
      fieldName: 'weightOunce',
      value: (
        <div>
          Weight in ounce. This is used to compute the shipping fee if the shippingWeight is not specified,{' '}
          <span className={'text-info fw-bold'}>REQUIRED*</span>
        </div>
      ),
    },
    {
      fieldName: 'shippingWeight',
      value: (
        <div>
          This is used to compute the shipping fee based on the weight and unit specified,{' '}
          <span className={'text-info fw-bold'}>REQUIRED*</span>
        </div>
      ),
    },
    {
      fieldName: 'weightPounds',
      value: <div>Weight in pounds</div>,
    },
    {
      fieldName: 'category',
      value: (
        <div>
          Category of the product. Valid values are <b className="text-info">{categoryOptions}</b>
        </div>
      ),
    },
    {
      fieldName: 'dieSetType',
      value: (
        <div>
          Die set type of the product. Valid values are <b className="text-info">{dieSetTypeOptions}</b>
        </div>
      ),
    },
    {
      fieldName: 'horizontalIn',
      value: <div>Height of product in inches. Can be use to filter on storefront</div>,
    },
    {
      fieldName: 'horizontalMm',
      value: <div>Height of product in millimeter. Can be use to filter on storefront</div>,
    },
    {
      fieldName: 'shape',
      value: (
        <div>
          Shape of the die. Valid values are <b className="text-info">{shapeOptions}</b>
        </div>
      ),
    },
    {
      fieldName: 'verticalIn',
      value: <div>Width of product in inches. Can be use to filter on storefront</div>,
    },
    {
      fieldName: 'verticalMm',
      value: <div>Width of product in millimeter. Can be use to filter on storefront</div>,
    },
  ]
}
